import { gsap, Expo } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';

export default function() {
  gsap.registerPlugin(CustomEase);
  // ANIMATIONS

  window.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);
    const deviceHeight = window.innerHeight;
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    /* TIMELINES */

    const timelines = document.querySelectorAll('.timeline');

    if (timelines) {
      timelines.forEach(timelineSection => {
        let animationElements = JSON.parse(
          timelineSection.getAttribute('data-animation-settings')
        );
        let pin = timelineSection.getAttribute('data-pin')
          ? timelineSection.getAttribute('data-pin')
          : true;
        let scrub = timelineSection.getAttribute('data-scrub')
          ? timelineSection.getAttribute('data-scrub')
          : 1;
        let start = timelineSection.getAttribute('data-start')
          ? timelineSection.getAttribute('data-start')
          : 'top top';
        let end = timelineSection.getAttribute('data-end')
          ? timelineSection.getAttribute('data-end')
          : '+=4000';
        let toggleActions = timelineSection.getAttribute('data-toggle-actions')
          ? timelineSection.getAttribute('data-toggle-actions')
          : 'play pause play reset';
        let mobileTimeline = timelineSection.getAttribute(
          'data-mobile-timeline'
        )
          ? timelineSection.getAttribute('data-mobile-timeline')
          : false;

        if (isDesktop || mobileTimeline === true) {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: timelineSection,
              pin: pin,
              scrub: scrub,
              start: start,
              end: end,
              toggleActions: toggleActions,
            },
          });

          animationElements.forEach(animationElement => {
            let animationType = animationElement.type;
            let element = animationElement.element;
            let animations = animationElement.animations;
            let delay = animationElement.delay;

            if (animationType == 'fromTo') {
              tl.fromTo(element, animations, delay);
            } else if (animationType == 'to') {
              tl.to(element, animations, delay);
            } else {
              tl.from(element, animations, delay);
            }
          });
        }
      });
    }

    /* ANIMATIONS */

    let animate = (selectors, from, to) => {
      let animateElements = document.querySelectorAll(selectors);
      let selectorsArray = selectors.split(',');
      let newSelectorsArray = [];

      console.log({animateElements});

      if (animateElements) {

      animateElements.forEach(element => {
        var wrapper = document.createElement('div');
        wrapper.classList.add('animation-wrapper');
        element.appendChild(wrapper);
        wrapper.appendChild(element.firstElementChild);
      });

      selectorsArray.forEach(selector => {
        selector = selector + ' .animation-wrapper';
        newSelectorsArray.push(selector);
      });

        gsap.defaults();
        gsap.set(newSelectorsArray, from);

        ScrollTrigger.batch(newSelectorsArray, {
          interval: 0.3, // time window (in seconds) for batching to occur.
          onEnter: batch => gsap.to(batch, to),
          onLeaveBack: batch => gsap.set(batch, from),
        });

        ScrollTrigger.addEventListener('refreshInit', () =>
          gsap.set(newSelectorsArray, { y: 0 })
        );
      }
    };

    animate(
      '.fadeup, body:not(.single) article',
      {
        y: 40,
        autoAlpha: 0,
      },
      {
        y: 0,
        autoAlpha: 1,
        duration: function(index, target) {
          return target.dataset.duration
            ? Number(target.dataset.duration)
            : 0.6;
        },
        ease: Expo.out,
        delay: function(index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.15,
        },
      }
    );

    animate(
      '.fadein',
      { autoAlpha: 0 },
      {
        autoAlpha: 1,
        duration: function(index, target) {
          return target.dataset.duration ? Number(target.dataset.duration) : 1;
        },
        ease: Expo.out,
        delay: function(index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.15,
        },
      }
    );

    animate(
      '.zoom-in',
      { scale: 1.1, autoAlpha: 0 },
      {
        scale: 1,
        autoAlpha: 1,
        duration: function(index, target) {
          return target.dataset.duration ? Number(target.dataset.duration) : 1;
        },
        delay: function(index, target) {
          return target.dataset.delay ? Number(target.dataset.delay) : 0;
        },
        stagger: {
          each: 0.15,
        },
      }
    );

    let revealContainers = document.querySelectorAll('.reveal');

    revealContainers.forEach(container => {
      let image = container.querySelector('img');
      let wrapper = container.querySelector('.elementor-widget-container');
      let yDirection = function() {
        return container.dataset.direction == 'down'
          ? '-100'
          : container.dataset.direction == 'left'
          ? '0'
          : container.dataset.direction == 'right'
          ? '0'
          : '100';
      };
      let xDirection = function() {
        return container.dataset.direction == 'left'
          ? '100'
          : container.dataset.direction == 'right'
          ? '-100'
          : 0;
      };
      let duration = function() {
        return container.dataset.duration
          ? Number(container.dataset.duration)
          : 1;
      };
      let delay = function() {
        return container.dataset.delay ? Number(container.dataset.delay) : 0.2;
      };

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          toggleActions: 'restart none none reset',
        },
      });

      tl.set(container, { autoAlpha: 1, delay: delay() });
      tl.from(wrapper, duration(), {
        yPercent: yDirection(),
        xPercent: xDirection(),
        ease: Expo.out,
      });
      tl.from(image, duration(), {
        yPercent: -yDirection(),
        xPercent: -xDirection(),
        scale: 1.3,
        delay: -duration(),
        ease: Expo.out,
      });
    });

    //PARALLAX

    gsap.utils.toArray('.parallax').forEach(element => {
      const topDistance = element.getBoundingClientRect().top;
      //const bottomDistance = element.getBoundingClientRect().bottom + element.offsetHeight ;
      let distanceToTop = window.pageYOffset + topDistance;
      const depth = element.dataset.depth ? element.dataset.depth : 0.3;
      const direction = element.dataset.direction;
      const mobileParallax = element.dataset.mobileParallax
        ? element.dataset.mobileParallax
        : true;
      const movement = -((element.offsetHeight / 2) * depth);
      const from = distanceToTop < deviceHeight ? 0 : -movement;

      if (isDesktop || mobileParallax === true) {
        const parallaxTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: element,
            start: function() {
              return topDistance <= deviceHeight
                ? 'top ' + topDistance
                : 'top bottom';
            },
            end: 'bottom top',
            scrub: true,
          },
        });
        if (direction == 'horizontal') {
          parallaxTimeline.fromTo(
            element,
            {
              x: topDistance <= deviceHeight ? 0 : -depth * 100,
            },
            {
              x: depth * 100,
              ease: 'none',
            }
          );
        } else {
          parallaxTimeline.fromTo(
            element,
            {
              y: from,
              ease: 'none',
            },
            {
              y: movement,
              ease: 'none',
            }
          );
        }
      }
    });

    // REVEAL TEXT

    var splitWords = function(selector, container) {
      var elements = container.querySelectorAll(selector);

      elements.forEach(function(el) {
        el.dataset.splitText = el.textContent;
        el.innerHTML = el.textContent
          .split(/\s/)
          .map(function(word) {
            return word
              .split('-')
              .map(function(word) {
                return '<span class="word">' + word + '</span>';
              })
              .join('<span class="hyphen">-</span>');
          })
          .join('<span class="whitespace"> </span>');
      });
    };

    var splitLines = function(selector, container) {
      var elements = container.querySelectorAll(selector);

      splitWords(selector, container);

      elements.forEach(function(el) {
        var lines = getLines(el);

        var wrappedLines = '';
        lines.forEach(function(wordsArr) {
          wrappedLines += '<span class="line"><span class="mask-up">';
          wordsArr.forEach(function(word) {
            wrappedLines += word.outerHTML;
          });
          wrappedLines += '</span></span>';
        });
        el.innerHTML = wrappedLines;
      });
    };

    var getLines = function(el) {
      var lines = [];
      var line;
      var words = el.querySelectorAll('span');
      var lastTop;
      for (var i = 0; i < words.length; i++) {
        var word = words[i];
        if (word.offsetTop != lastTop) {
          // Don't start with whitespace
          if (!word.classList.contains('whitespace')) {
            lastTop = word.offsetTop;

            line = [];
            lines.push(line);
          }
        }
        line.push(word);
      }
      return lines;
    };

    if (document.querySelector('.reveal-text')) {
      gsap.utils.toArray('.reveal-text').forEach(revealText => {
        let type = revealText.dataset.type;
        gsap.defaults();
        gsap.set(revealText, { autoAlpha: 1 });

        if (type == 'letter') {
          let element = revealText.querySelector('h1,h2,h3,h4,h5,h6');

          element.innerHTML = element.textContent.replace(
            /([-A-Za-z0-9!$#%^&*@()_+|~=`{}[\]:";'<>?,./]+)/g,
            '<div class="word inline-flex">$1</div>'
          );

          let words = element.querySelectorAll('.word');
          words.forEach(word => {
            word.innerHTML = word.textContent.replace(
              /[-A-Za-z0-9!$#%^&*@()_+|~=`{}[\]:";'<>?,./]/g,
              "<div class='perspective'><div class='letter'><div>$&</div></div></div>"
            );
          });

          const letters = element.querySelectorAll('.letter');

          let tl = gsap.timeline({
            scrollTrigger: {
              trigger: element,
              toggleActions: 'restart none none reset',
            },
          });

          tl.fromTo(
            letters,
            1.6,
            {
              transformOrigin: 'center',
              rotationY: 90,
              x: 30,
            },
            {
              rotationY: 0.1,
              x: 0,
              stagger: 0.025,
              ease: CustomEase.create('custom', 'M0,0 C0.425,0.005 0,1 1,1'),
            }
          );
        } else {
          splitLines('h1, h2, h3, h4, h5, h6', revealText);
          let lines = revealText.querySelectorAll('.mask-up');
          gsap.set(lines, { yPercent: 100 });
          ScrollTrigger.batch(lines, {
            interval: 0.16,
            onEnter: batch =>
              gsap.to(batch, {
                yPercent: 0,
                duration: function(index, target) {
                  return revealText.dataset.duration
                    ? Number(target.closest('.reveal-text').dataset.duration)
                    : 0.5;
                },
                delay: function(index, target) {
                  return revealText.dataset.delay
                    ? Number(target.closest('.reveal-text').dataset.delay)
                    : 0.1;
                },
                ease: CustomEase.create('custom', 'M0,0 C0.425,0.005 0,1 1,1'),
                stagger: { each: 0.15 },
                overwrite: true,
              }),
            onLeaveBack: batch =>
              gsap.set(batch, { yPercent: 100, overwrite: true }),
          });
        }
      });

      ScrollTrigger.addEventListener('refreshInit', () =>
        gsap.set('.reveal-text', { y: 0 })
      );
    }
  });
}
